import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

function TipPri(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{
                    document.title = getTitle(confPantalla.config.trad, confPantalla.tippri.title);                                        
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveEstadoFormPrin(confPantalla.tippri.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.tippri.hijo.estadoform);                             
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.tippri.padre.urls);
                                saveFormularioPrin(confPantalla.tippri.padre.modelform);
                                saveFormularioHijo(confPantalla.tippri.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.tippri.padre.urls, confPantalla.tippri.hijo.urls, confPantalla.tippri.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);  
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.tippri.section.titulo } icono={ confPantalla.tippri.section.icono } col={ confPantalla.tippri.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.tippri.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.tippri.padre.btnform.new }
                                        btnSave={ confPantalla.tippri.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.tippri.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.tippri.padre.btnform.delete }
                                        btnClone={ confPantalla.tippri.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.tippri.padre.urls, confPantalla.tippri.padre.modelform, confPantalla.tippri.padre.tabla, confPantalla.tippri.hijo.modelform, confPantalla.tippri.title) } 
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.tippri.padre.modelform, true, confPantalla.tippri.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.tippri.padre.urls, confPantalla.tippri.padre.modelform, confPantalla.tippri.padre.tabla, confPantalla.tippri.title) } 
                            >         
                                <FormRow clases="" >                                                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tippri.padre.controles.nom.id }   
                                        type=       { confPantalla.tippri.padre.controles.nom.type }  
                                        name=       { confPantalla.tippri.padre.controles.nom.name }   
                                        label=      { confPantalla.tippri.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.tippri.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.tippri.padre.controles.nom.col } 
                                        required=   { confPantalla.tippri.padre.controles.nom.required }
                                        readonly=   { confPantalla.tippri.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.tippri.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom_en }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tippri.padre.controles.nom_en.id }   
                                        type=       { confPantalla.tippri.padre.controles.nom_en.type }  
                                        name=       { confPantalla.tippri.padre.controles.nom_en.name }   
                                        label=      { confPantalla.tippri.padre.controles.nom_en.label }                                                       
                                        placeholder={ confPantalla.tippri.padre.controles.nom_en.placeholder }    
                                        col=        { confPantalla.tippri.padre.controles.nom_en.col } 
                                        required=   { confPantalla.tippri.padre.controles.nom_en.required }
                                        readonly=   { confPantalla.tippri.padre.controles.nom_en.readonly }                                                
                                        disabled=   { confPantalla.tippri.padre.controles.nom_en.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>                            
                            </Formulario>
                            <MiDataTable
                                formulario={formularioPrin} 
                                estadoForm= { estadoFormPrin }
                                id={"tippri"}
                                columnas={confPantalla.tippri.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.tippri.padre.datatable.buttons}
                                ordering={confPantalla.tippri.padre.datatable.ordering}
                                order={confPantalla.tippri.padre.datatable.order}
                                searching={confPantalla.tippri.padre.datatable.searching}
                                paging={confPantalla.tippri.padre.datatable.paging}
                                select={confPantalla.tippri.padre.datatable.select}
                                pagelength={confPantalla.tippri.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.tippri.padre.urls, confPantalla.tippri.hijo.urls, confPantalla.tippri.padreshijos, confPantalla.tippri.hijo.modelform, confPantalla.tippri.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.tippri.padre.urls, confPantalla.tippri.padre.modelform, confPantalla.tippri.padre.tabla, confPantalla.tippri.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.tippri.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default TipPri